var React = require('react');

function ArrowUpRightRegular (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.3649 1.66632V10.1922C12.3649 10.6629 11.983 11.0448 11.5123 11.0448C11.0416 11.0448 10.6597 10.6629 10.6597 10.1922V3.7232L2.45355 11.9294C2.28587 12.0999 2.06775 12.1816 1.84963 12.1816C1.63151 12.1816 1.41339 12.0984 1.24678 11.9318C0.913733 11.5988 0.913733 11.0594 1.24678 10.7261L9.45546 2.51891H2.98642C2.51572 2.51891 2.13383 2.1388 2.13383 1.66632C2.13383 1.19384 2.51572 0.813721 2.98642 0.813721H11.5123C11.9848 0.813721 12.3649 1.1974 12.3649 1.66632Z","fill":"#242426"}));
}

ArrowUpRightRegular.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = ArrowUpRightRegular;

ArrowUpRightRegular.default = ArrowUpRightRegular;
